import React, { useState } from "react";

import { Modal } from '~/components/common';
import Button from "../../common/Button";
import { trans } from '../../../utilities';

export default function LicensePlateModal({ proceeding, licensePlateParam, mileageParam, vehicles, userName, onClose }) {
    const [selectedVehicle, setSelectedVehicle] = useState(vehicles[0]);
    const handleProceed = () => {
        const hasParam = licensePlateParam !== '' || mileageParam !== '';
        let url = proceeding;
        if (hasParam) url = url += `${url.includes('?') ? '&' : '?'}${licensePlateParam && licensePlateParam !== '' ? `${licensePlateParam}=${selectedVehicle.licensePlate}${mileageParam && mileageParam!== '' ? '&' : ''}` : ``}${mileageParam && mileageParam!== '' ? `${mileageParam}=${selectedVehicle.mileage}` : ``}`

        window.open(url, '_blank');
    };

    return (
        <Modal
            className="modal--sticker"
            open={true}
            handleClose={onClose}
            modalTitle={trans(`app.extranet.dashboard.modal.label`)}
            modalBody={(
                <div className="row gutters-4 gutters-xl-10">
                    <div className="col-12">
                        <div className="vehicle-plates d-flex flex-column gap-1">
                            <h2 className="font-weight-bold mb-5">{trans(`app.extranet.dashboard.modal.title`, { 'user': userName })}</h2>
                            {vehicles.map((vehicle, index) => (
                                <div key={index} className="vehicle-plate">
                                    <div className="custom-radio custom-radio--expanded">
                                        <input
                                            name="proceeding"
                                            id={vehicle.id}
                                            className="custom-radio-input"
                                            type="radio"
                                            checked={selectedVehicle === vehicle}
                                            onChange={() => setSelectedVehicle(vehicle)}
                                        />
                                        <label htmlFor={vehicle.id} className="custom-radio-label d-flex flex-row justify-content-between align-items-center">
                                            <span>{vehicle.brand} {vehicle.model}</span>
                                            <span className="license-plate-extranet">{vehicle.licensePlate}</span>
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <Button className="mt-6" theme="secondary" title="Ga verder" onClick={handleProceed} />
                    </div>
                </div>
            )}
        />
    );
}
